// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import UserSettingsNavigationItem from './user-settings-navigation-item';

const UserSettingsNavigationList = ({routes}) =>
    <ul className='user-settings-navigation-list'>
        {routes.map((route, index) =>
            <UserSettingsNavigationItem
                key={index}
                label={route.name}
                path={route.path}
            />
        )}
    </ul>;

UserSettingsNavigationList.displayName = 'UserSettingsNavigationList';
UserSettingsNavigationList.propTypes = {
    routes: PropTypes.array.isRequired
};

export default UserSettingsNavigationList;



// WEBPACK FOOTER //
// ./src/user/shared/components/user-settings/user-settings-navigation-list.js